import { FC } from 'react'

import DialogWindow from '@/components/DialogWindow'

import Cancel from '@/assets/icons/cancel-3.svg'
import Copy from '@/assets/icons/copy.svg'

interface IHighlightShareDialog {
	open: boolean
	shareUrl: string
	onClose: () => void
	onCopy: () => void
}

const HighlightShareDialog: FC<IHighlightShareDialog> = ({
	open,
	shareUrl,
	onClose,
	onCopy
}) => {
	return (
		<DialogWindow
			open={open}
			onClose={onClose}
			handleClick={onCopy}
			titleText='Copy share link'
			body={
				<div className='break-all rounded-[8px] bg-neutral-100 p-3 text-neutral-900'>
					{shareUrl}
				</div>
			}
			noButtonText={
				<>
					<Cancel className='w-3 h-3' />
					<span>Cancel</span>
				</>
			}
			yesButtonText={
				<>
					<Copy className='w-3 h-3 text-white' />
					<span>Copy link</span>
				</>
			}
			noButtonClassname='!text-[16px] hover:bg-neutral-200'
			noButtonClassnameText='flex items-center gap-3'
			yesButtonClassname='bg-neutral-900 hover:bg-neutral-700'
			yesButtonClassnameText='flex items-center gap-3'
		/>
	)
}

export default HighlightShareDialog
